import React from 'react';

const airline = (props) => {
    const airlines = props.airlineNames;
    const FS = props.FS;
    let airline = '';

    for (let airlineCode in airlines) {
        if (FS[0].ac === airlineCode) {
            airline = airlines[airlineCode];
        }
    }
    return <span className="u-fontSize13 u-phone-fontSize11 u-textColorMedium u-lineHeight15 u-block u-width90 u-phone-widthAuto u-noWrapWithEllipsis">{airline}</span>;
}

export default airline;


// WEBPACK FOOTER //
// ./src/components/Flight/Airline/AirlineName/AirlineName.js